export const formatMoney = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' Kč';
}

export const formatMoneyNoCurrency = (value, lang) => {
  let append = " "
  if (value > 1000000) {
    value = Math.round(value/100000) / 10
    if (lang === 'cs') {
      append = " mil. "
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ",") + append;
    }
    else
      append = " mio. "
  }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + append;
}



// WEBPACK FOOTER //
// ./src/browser/lib/utils.js